import { defineMessages } from 'react-intl';
import { SportTermLookup, SportTerminology } from '../../../lib/types';

export const scope = 'app.components.DrillList';

export const getMessages = (termLookup: SportTermLookup) => {
  return defineMessages({
    lblNoDiagram: {
      id: `${scope}.lblNoDiagram`,
      defaultMessage: 'No Diagram Available'
    },
    errUploadImage: {
      id: `${scope}.errUploadImage`,
      defaultMessage: `Couldn't upload the ${termLookup[SportTerminology.EVENT].toLowerCase()} diagram. Please try again.`
    }
  });
}
